import React from 'react';
import HandMenuModal from './HandMenuModal';
import DeckMenuModal from './DeckMenuModal';
import ExtraMenuModal from './ExtraMenuModal';
import ZoneCardModal from './ZoneCardModal';
import FieldCardModal from './FieldCardModal';
import ExtraCardModal from './ExtraCardModal';
import CardRevealModal from './CardRevealModal';
import DeckModal from './DeckModal';
import ZoneViewerModal from './ZoneViewerModal';

const AllModals = ({
  handMenuCard,
  onHandAction, // ✅ Add this
  setHandMenuCard,
  showDeckMenu,
  setShowDeckMenu,
  onDeckAction,
  showExtraMenu,
  setShowExtraMenu,
  onExtraDeckAction,
  zoneCardModal,
  setZoneCardModal,
  onZoneCardAction,
  fieldCard,
  setFieldCard,
  onFieldCardAction,
  extraCardModalCard,
  setExtraCardModalCard,
  onExtraCardAction,
  revealCard,
  revealTitle,
  setRevealCard,
  showDeckModal,
  setShowDeckModal,
  mainDeck,
  viewZoneCards,
  setViewZoneCards,
  zoneViewerTitle,
  onCardClickFromZone
}) => {
  return (
    <>
      {handMenuCard && (
        <HandMenuModal
          card={handMenuCard}
          onAction={onHandAction}
          onClose={() => setHandMenuCard(null)}
        />
      )}

      <DeckMenuModal
        visible={showDeckMenu}
        onAction={(action) => {
          onDeckAction(action);
          setShowDeckMenu(false);
        }}
        onClose={() => setShowDeckMenu(false)}
      />

      <ExtraMenuModal
        visible={showExtraMenu}
        onAction={(action) => {
          onExtraDeckAction(action);
          setShowExtraMenu(false);
        }}
        onClose={() => setShowExtraMenu(false)}
      />

      {zoneCardModal && (
        <ZoneCardModal
          card={zoneCardModal.card}
          origin={zoneCardModal.origin}
          onClose={() => setZoneCardModal(null)}
          onAction={(action) =>
            onZoneCardAction(action, zoneCardModal.card, zoneCardModal.origin)
          }
        />
      )}

      {fieldCard && (
        <FieldCardModal
          card={fieldCard}
          onClose={() => setFieldCard(null)}
          onAction={(action) => onFieldCardAction(action, fieldCard)}
        />
      )}

      {extraCardModalCard && (
        <ExtraCardModal
          card={extraCardModalCard}
          onAction={onExtraCardAction}
          onClose={() => setExtraCardModalCard(null)}
        />
      )}

      <CardRevealModal
        card={revealCard}
        title={revealTitle}
        onClose={() => setRevealCard(null)}
      />

      {showDeckModal && (
        <DeckModal mainDeck={mainDeck} onClose={() => setShowDeckModal(false)} />
      )}

      {viewZoneCards.length > 0 && (
        <ZoneViewerModal
          cards={viewZoneCards}
          title={zoneViewerTitle}
          onClose={() => setViewZoneCards([])}
          onCardClick={onCardClickFromZone}
        />
      )}
    </>
  );
};

export default AllModals;
